import React, { FC } from "react"

const EyeOffIcon: FC = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M14.12 14.122C13.8454 14.4167 13.5141 14.6531 13.1462 14.8171C12.7782 14.9811 12.3809 15.0692 11.9781 15.0763C11.5753 15.0835 11.1752 15.0094 10.8016 14.8585C10.4281 14.7076 10.0887 14.483 9.80385 14.1981C9.51897 13.9133 9.29439 13.5739 9.14351 13.2004C8.99262 12.8268 8.91853 12.4267 8.92563 12.0239C8.93274 11.6211 9.02091 11.2238 9.18488 10.8558C9.34884 10.4878 9.58525 10.1566 9.88 9.88198M17.94 17.942C16.2306 19.245 14.1491 19.9668 12 20.002C5 20.002 1 12.002 1 12.002C2.24389 9.68387 3.96914 7.65859 6.06 6.06198L17.94 17.942ZM9.9 4.24198C10.5883 4.08086 11.2931 4.00032 12 4.00198C19 4.00198 23 12.002 23 12.002C22.393 13.1376 21.6691 14.2067 20.84 15.192L9.9 4.24198Z"
          stroke="#2F3B5A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1.00195L23 23.002"
          stroke="#2F3B5A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.00195312)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EyeOffIcon
